export default {
  isLoading: false,
  NavMenuActive: '/',
  userInfo: {},
  headUser: {},
  // 登陆返回的企业信息
  corporationInfo: {},
  // 当前默认是404 无权限
  userName: '',
  is404: true,
  headNavActive: '/',
  // 可以切换的企业列表数据
  companyList: [],
  // 是否显示切换企业的弹框
  isCompanyModal: false,
  vueScrollOps: {
    bar: {
      background: '#E4E8ED',
    },
  },
  companyName: '',
  menuTop: [],
  admin: false,
  creator: false,
  corpCertityStatus: false,
  userCertityStatus: false,
  isopen: false,
  openflag: true,
  checked: false,
  isDialog: true,
  axiosAll: [],
  accountInfo: {
    // 可用余额
    cashAccount: 0,
    // ETC积分
    etcIntegralAccount: 0,
    // 可开发票
    invoiceAccount: 0,
  },
  // 经办人短信验证码有效性
  agentSMSValidateStatus: '',
};
